import { TheWestSection } from '@news-mono/common'
import { getSocialImageMeta, StaticRoutes } from '@news-mono/web-common'
import { layout } from '../../App.routing'

export const getAppDownloadRouteInfo: StaticRoutes<TheWestSection> = {
    '/app': ({ getAdTargeting, config }) => {
        const canonicalLink = config.publicUrl + '/app'
        const socialImage = require('./assets/app-page-social.jpg')

        return {
            kind: 'page',
            heading: 'The West Australian news app for iOS and Android',
            hideHeading: true,
            pageType: 'static',
            pageMeta: {
                title: `The West Australian news app for iOS and Android`,
                description: `Download The West Australian app now to unlock premium access to the best in news, opinion, sport, business, politics, lifestyle, entertainment, travel, and more from WA's biggest and most experienced newsroom.`,
                link: [{ rel: 'canonical', href: canonicalLink }],
                meta: getSocialImageMeta(socialImage, '630', '1200'),
            },
            adTargeting: getAdTargeting('home', 'default', 'app'),
            section: 'default',
            additionalPageProperties: {
                fullPageWidth: true,
            },
            compositions: [
                layout.composition({
                    type: 'thor',
                    props: {
                        hasBackgroundFill: false,
                        containerWidth: '100%',
                        horizontalGutters: false,
                        verticalGutters: false,
                    },
                    contentAreas: {
                        main: [
                            layout.component({
                                type: 'tw-app-download-page',
                                props: {},
                            }),
                        ],
                    },
                }),
            ],
        }
    },
}
